export const DEFAULT_AUTO_DETECT_COLOR_SCHEME_ATTRS = ["class", "data-theme"];
